import Vue from 'vue'
import Sessies from '../vue/Sessies.vue'

export default {
  init() {
    new Vue({
      el: '#app',
      components: {
        Sessies,
      },
    })
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/sessies.js